interface PageMetaProps {
  title: string;
  description: string;
  keywords: string;
}

/**
 * React 19 hoists <title> / <meta> / <link> rendered inside a component into <head>.
 */
export default function PageMeta({ title, description, keywords }: PageMetaProps) {
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </>
  );
}